export default "__VITE_ASSET__c4z4HRO$__"